<template>
    <div class="shopping_cart_table_box">
        <!-- 表格 -->
        <el-table
            :data="cart"
            ref="cartTable"
            tooltip-effect="dark"
            :row-key="getRowKeys"
			empty-text="暫無數據"
            @selection-change="handleSelect">
            <!-- 多选框 -->
            <el-table-column
                type="selection"
                :reserve-selection="true"
                align="center"
                width="55">
            </el-table-column>
            <!-- 商品名称 -->
            <el-table-column
                :label="$t('message.cart.table1')"
                align="center"
                width="250"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div class="shopping_cart_goods">
                        <!-- 图片 -->
                        <router-link
                            :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }"
                            class="shopping_cart_goods_img">
                            <img :src="row.goods_images[0]" alt="">
                        </router-link>
                        <!-- 图片 -->
                        <router-link
                            :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }"
                            class="shopping-cart-goods-title">
                            <span>{{filterTitle(row)}}</span>
                        </router-link>
                    </div>
                </template>
            </el-table-column>
            <!-- 单价 -->
            <el-table-column
                :label="$t('message.cart.table2')"
                align="center"
                show-overflow-tooltip
                v-if="powerPrice">
                <template v-slot="{ row }">
                    <div class="shopping_cart_goods_price">{{row.goods_price}}</div>
                </template>
            </el-table-column>
            <!-- 计数器 -->
            <el-table-column
                :label="$t('message.cart.table3')"
                align="center"
                width="110">
                <template v-slot="{ row }">
                    <el-input-number
                        :value="row.goods_number"
                        size="mini"
                        :min="1"
                        class="shopping_cart_input_number"
                        @change="handleNum($event,row)">
                    </el-input-number>
                </template>
            </el-table-column>
            <!-- 单位 -->
            <el-table-column
                :label="$t('message.cart.table4')"
                align="center"
                show-overflow-tooltip
                v-if="powerPrice">
                <template v-slot="{ row }">
                    <div class="shopping_cart_goods_price">
                        {{countPrice(row.goods_price,row.goods_number)}}
                    </div>
                </template>
            </el-table-column>
            <!-- 类型 -->
           <el-table-column
                :label="$t('message.cart.table5')"
                align="center"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <el-select
                        :value="row.goods_attr"
                        size="mini"
                        @change="handleAttr($event,row)"
                        :disabled="!row.goods_attr_id">
                        <el-option
                            v-for="(item,index) in row.attr"
                            :key="index"
                            :label="item.attr_value"
                            :value="item.goods_attr_id">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <!-- 删除 -->
            <el-table-column
                :label="$t('message.cart.table6')"
                align="center">
                <template v-slot="{ row }">
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDel($event,row.rec_id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 合计行 -->
        <div class="shopping_cart_table_total_box">
            <!-- 删除选中商品 -->
            <el-button
                type="text"
                class="shopping_cart_table_btn"
                @click="handleDel">
                <span>{{$t("message.cart.delAllBtn")}}</span>
            </el-button>
            <!-- 右侧统计&添加 -->
            <div class="shopping_cart_table_total">
                <!-- 数量统计 -->
                <div class="shopping_cart_table_total_num_box">
                    <span>{{$t("message.cart.total1")}}</span>
                    <span class="shopping_cart_table_total_num">{{totalMsg.num}}</span>
                    <span>{{$t("message.cart.total2")}}</span>
                </div>
                <!-- 价格统计 -->
                <div class="shopping_cart_table_total_num_box"
                    v-if="powerPrice">
                    <span>{{$t("message.cart.total3")}}</span>
                    <span class="shopping_cart_table_total_num">{{currency}}</span>
                    <span class="shopping_cart_goods_price">{{totalMsg.price}}</span>
                </div>
                <!-- 结算 -->
                <el-button
                    type="primary"
                    @click="submitCart"
                    class="shopping_cart_table_btn">
                    <span>{{$t("message.cart.submitBtn")}}</span>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    data() {
        return {
            select_list: [], // 选中列表
        }
    },
    computed: {
        ...mapState({
            power: state => state.user.power,
            currency: state => state.currency,
            cart: state => state.order.cart,
        }),
        ...mapGetters([
            'powerPrice',
        ]),
        totalMsg(){
            let num = 0, price = 0;
            for(let item of this.select_list){
                this.cart.find((source, index, arr) => {
                    if(source.rec_id == item){
                        price += Number(source.goods_number) * Number(source.goods_price);
                        num += Number(source.goods_number);
                    }
                })
            }
            return {
                price: price.toFixed(2),
                num
            };
        },
        
    },
    methods: {
        ...mapMutations([
            "setCartOrder"
        ]),
        ...mapActions([
            "handleCartNum",
            "handleCartDel"
        ]),
        filterTitle(row) {
            let spec = '';
            if(row.goods_specification) {
                spec = `[${this.$t('message.cart.spec')}]：${row.goods_specification} -- `
            }
            return spec + row.goods_name;
        },
        countPrice(unit, num){ // 合计价格计算
            return (Number(unit) * Number(num)).toFixed(2);
        },
        getRowKeys(row){ // 行key
            return row.rec_id
        },
        handleSelect(val){ // 选项发生改变时
            let new_val = [];
            for(let item of val){
                new_val.push(item.rec_id)
            }
            this.select_list = new_val;
        },
        handleNum(goods_number,item){ // 购物车数量更改
            let { rec_id, goods_attr_id } = item;
            this.handleCartNum({
                rec_id,
                goods_attr_id,
                goods_number
            }).then((res) => {
                if(res.type === false){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cart.errmsg5"),
                        type: "error"
                    })
                }
            })
        },
        handleAttr(goods_attr_id, item){ // 下拉框处理函数
            let { rec_id, goods_number } = item;
            this.handleCartNum({
                rec_id,
                goods_attr_id,
                goods_number
            })
        },
        handleDel($event,id){ // 删除购物车
            let rec_id = [];
            if(id){
                rec_id.push(id)
            }else{
                rec_id = this.select_list;
            }
            if(rec_id.length == 0){ // 判定是否有删除商品id
                this.$message({
                    showClose: true,
                    message: this.$t("message.cart.errmsg1"),
                    type: "warning"
                })
                return
            }
            this.cart.find((val, index, arr) => {
                if(rec_id.includes(val.rec_id)){
                    this.$refs.cartTable.toggleRowSelection(val,false);
                }
            })
            this.handleCartDel(rec_id).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: this.$t("public.delSucc"),
                        type: "success"
                    })
                }
            })
        },
        submitCart(){ // 提交购物车
            let allow = this.power.includes(0) || this.power.includes(111) || this.power.includes(7);
            if(!allow){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cart.errmsg4"),
                    type: "error"
                })
                return
            }
            if(this.select_list.length == 0){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cart.errmsg1"),
                    type: "warning"
                })
                return;
            }
            this.$confirm(this.$t("message.cart.confirmMsg"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(() => {
                let new_arr = [];
                this.cart.find((val, index, arr) => {
                    if(this.select_list.includes(val.rec_id)){
                        new_arr.push(val)
                    }
                })
				//只传入 rec_id
				let rec_id = [];
				this.cart.find((val, index, arr) => {
				    if(this.select_list.includes(val.rec_id)){
				        rec_id.push(val.rec_id)
				    }
				})
				let array = []
				array.push(new_arr,rec_id)
                this.setCartOrder(array);
                this.$router.push("/cartOrder");
            }).catch(() => {})
        }
    },
    mounted() {
        this.$refs.cartTable.toggleAllSelection();
    }
}
</script>

<style scoped>
.shopping_cart_table_box{
    background: #fff;
}
/* 商品参数盒子 */
.shopping_cart_goods{
    text-align: left;
}
.shopping_cart_goods>a{
    display: inline-block;
    vertical-align: middle;
}
/* 商品图片 */
.shopping_cart_goods_img{
    position: relative;
    width: 50px;
    height: 50px;
    margin-right: 5px;
}
.shopping_cart_goods_img>img{
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
/* 商品标题 */
.shopping-cart-goods-title{
    width: 180px;
    height: 45px;
    overflow: hidden;
    white-space: normal;
}
/* 价格 */
.shopping_cart_goods_price{
    color: #ff6700;
}
/* 计数器 */
.shopping_cart_input_number{
    width: 100px;
}

/* 统计区域 */
.shopping_cart_table_total_box{
    height: 50px;
    background-color: #EBEEF5;
}
/* 右侧部分 */
.shopping_cart_table_total{
    float: right;
}
/* 数量统计 */
.shopping_cart_table_total_num_box{
    display: inline-block;
    margin-right: 15px;
    line-height: 50px;
}
.shopping_cart_table_total_num{
    margin: 0 5px;
    color: #ff6700;
}
/* 按钮 */
.shopping_cart_table_btn{
    width: 115px;
    height: 50px;
}
</style>
